/**
 * @generated SignedSource<<8dab81180a80e01a63d4f3a952f802c0>>
 * @relayHash 1302c4a9b3b649820c1790e32a4ce993
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a74b757a72309cfeca0a9eff76734f5ee98ea1365650ad184b121db44ca014f8

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_prefetchCascadingSelectFieldOptionsQuery$variables = {
  first?: number | null | undefined;
  id: string;
};
export type ui_prefetchCascadingSelectFieldOptionsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment">;
};
export type ui_prefetchCascadingSelectFieldOptionsQuery = {
  response: ui_prefetchCascadingSelectFieldOptionsQuery$data;
  variables: ui_prefetchCascadingSelectFieldOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "searchBy",
    "value": ""
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "value"
},
v8 = {
  "kind": "ScalarField",
  "name": "isDisabled"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_prefetchCascadingSelectFieldOptionsQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ui_prefetchCascadingSelectFieldOptionsQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "JiraParentOptionConnection",
                "kind": "LinkedField",
                "name": "parentOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraParentOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraParentOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "concreteType": "JiraOptionConnection",
                            "kind": "LinkedField",
                            "name": "childOptions",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraOption",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v5/*: any*/),
                "filters": [
                  "searchBy",
                  "filterById"
                ],
                "handle": "connection",
                "key": "cascadingSelect_issueFieldCascadingSelectEditviewFull_parentOptions",
                "kind": "LinkedHandle",
                "name": "parentOptions"
              }
            ],
            "type": "JiraCascadingSelectField"
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "a74b757a72309cfeca0a9eff76734f5ee98ea1365650ad184b121db44ca014f8",
    "metadata": {},
    "name": "ui_prefetchCascadingSelectFieldOptionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4ea277c1bd2765da3a550f42a3098fc3";

export default node;
